/* ══════════════════════════════════════════════════════════════
   Telugu (te) — తెలుగు Translation File
   ══════════════════════════════════════════════════════════════ */

export const te = {
    app: {
        name: 'ఇండియా మార్కెట్ మానిటర్',
        tagline: 'AI-ఆధారిత భారతీయ మార్కెట్ మేధస్సు',
    },
    nav: {
        dashboard: 'డాష్‌బోర్డ్',
        strategy: 'వ్యూహం',
        intelligence: 'మేధస్సు',
        markets: 'మార్కెట్లు',
        indiaMap: 'భారత పటం',
        ipoEarnings: 'IPO & ఆదాయాలు',
        backtest: 'బ్యాక్‌టెస్ట్',
        settings: 'సెట్టింగ్‌లు',
        search: 'కంపెనీ, వార్తలు వెతకండి…',
    },
    dashboard: {
        title: 'డాష్‌బోర్డ్',
        marketStatus: 'మార్కెట్ స్థితి',
        open: 'తెరిచి ఉంది',
        closed: 'మూసివేయబడింది',
        preOpen: 'ముందు-తెరిచే',
        holiday: 'సెలవు',
        strategyCard: 'నేటి వ్యూహం',
        marketRadar: 'మార్కెట్ రాడార్',
        fiiDii: 'FII / DII ప్రవాహాలు',
        quickStats: 'శీఘ్ర గణాంకాలు',
        newsTicker: 'ప్రాధాన్యత వార్తలు',
        liveTV: 'లైవ్ టీవీ',
        viewDetails: 'వివరాలు చూడండి →',
    },
    strategy: {
        title: 'వ్యూహం',
        regime: 'మార్కెట్ పరిస్థితి',
        regimeTypes: {
            trendingBull: 'బుల్లిష్ ట్రెండ్',
            trendingBear: 'బేరిష్ ట్రెండ్',
            sideways: 'సైడ్‌వేస్',
            highVol: 'అధిక అస్థిరత',
        },
        confidence: 'విశ్వాసం',
        entry: 'ఎంట్రీ',
        target: 'లక్ష్యం',
        stopLoss: 'స్టాప్ లాస్',
        buy: 'కొనండి',
        sell: 'అమ్మండి',
        hold: 'హోల్డ్',
        featureImportance: 'ఫీచర్ ప్రాముఖ్యత',
        keyLevels: 'కీలక స్థాయిలు',
        support: 'సపోర్ట్',
        resistance: 'రెసిస్టెన్స్',
        currentPrice: 'ప్రస్తుత ధర',
    },
    intelligence: {
        title: 'మేధస్సు',
        morningBrief: 'ఉదయ సంక్షిప్తం',
        priorityFeed: 'ప్రాధాన్యత ఫీడ్',
        sectorIntel: 'రంగ మేధస్సు',
        earningsTracker: 'ఆదాయాలు',
        eventTimeline: 'సంఘటనలు',
        newsSearch: 'వెతకండి',
        bullish: 'బుల్లిష్',
        bearish: 'బేరిష్',
        neutral: 'తటస్థ',
    },
    markets: {
        title: 'మార్కెట్లు',
        indices: 'సూచీలు',
        options: 'ఆప్షన్లు',
        sectors: 'రంగాలు',
        commodities: 'వస్తువులు',
        currency: 'కరెన్సీ',
        breadth: 'బ్రెడ్త్',
        advancing: 'పెరుగుతున్నవి',
        declining: 'తగ్గుతున్నవి',
    },
    ipo: {
        title: 'IPO & ఆదాయాలు',
        dashboard: 'IPO డాష్‌బోర్డ్',
        earningsTracker: 'ఆదాయ ట్రాకర్',
        upcoming: 'రాబోయే IPO',
        subscribe: 'సబ్‌స్క్రైబ్',
        avoid: 'నివారించండి',
        revenue: 'ఆదాయం',
        verdict: 'తీర్పు',
        beat: 'బీట్',
        miss: 'మిస్',
    },
    backtest: {
        title: 'బ్యాక్‌టెస్ట్',
        equityCurve: 'ఈక్విటీ కర్వ్',
        riskMetrics: 'రిస్క్ మెట్రిక్స్',
        monthlyReturns: 'నెలవారీ రిటర్న్',
        tradeLog: 'ట్రేడ్ లాగ్',
        totalReturn: 'మొత్తం రిటర్న్',
        winRate: 'విజయ రేటు',
    },
    map: {
        title: 'భారత పటం',
        selectState: 'రాష్ట్రాన్ని ఎంచుకోండి',
        gdp: 'GDP',
        growth: 'వృద్ధి',
        keySectors: 'కీలక రంగాలు',
    },
    settings: {
        title: 'సెట్టింగ్‌లు',
        language: 'భాష',
        selectLanguage: 'భాషను ఎంచుకోండి',
        darkMode: 'డార్క్ మోడ్',
        lightMode: 'లైట్ మోడ్',
    },
    sectorRotation: {
        title: 'రంగ భ్రమణం',
        leading: 'ముందున్న',
        weakening: 'బలహీనమవుతున్న',
        lagging: 'వెనుకబడిన',
        improving: 'మెరుగుపడుతున్న',
    },
    election: {
        title: 'ఎన్నికల ప్రభావం',
        upcomingElections: 'రాబోయే ఎన్నికలు',
        state: 'రాష్ట్రం',
        historicalImpact: 'చారిత్రిక నిఫ్టీ ప్రభావం',
        avgReturn: 'సగటు నిఫ్టీ రిటర్న్',
    },
    budget: {
        title: 'బడ్జెట్ ప్రభావం',
        unionBudget: 'కేంద్ర బడ్జెట్ 2026-27',
        daysLeft: '{{days}} రోజులు మిగిలి ఉన్నాయి',
        increase: 'పెరుగుదల',
        decrease: 'తగ్గుదల',
    },
    common: {
        loading: 'లోడ్ అవుతోంది…',
        error: 'ఏదో తప్పు జరిగింది',
        retry: 'మళ్ళీ ప్రయత్నించండి',
        noData: 'డేటా అందుబాటులో లేదు',
        viewAll: 'అన్నీ చూడండి',
        close: 'మూసివేయండి',
        save: 'సేవ్',
        cancel: 'రద్దు',
        crore: 'కోట్లు',
        lakh: 'లక్షలు',
        rupee: '₹',
        disclaimer: 'ఇది ఆర్థిక సలహా కాదు. సమాచార ప్రయోజనాల కోసం మాత్రమే.',
    },
};
